export const actions = {
  PROVINCIAS_LOAD_REQUESTED: 'PROVINCIAS_LOAD_REQUESTED',
  PROVINCIAS_LOAD_SUCCEEDED: 'PROVINCIAS_LOAD_SUCCEEDED',
  PROVINCIAS_LOAD_FILED: 'PROVINCIAS_LOAD_FILED',

  PROVINCIA_UPDATE_REQUESTED: 'PROVINCIA_UPDATE_REQUESTED',
  PROVINCIA_UPDATE_SUCCEEDED: 'PROVINCIA_UPDATE_SUCCEEDED',
  PROVINCIA_UPDATE_FILED: 'PROVINCIA_UPDATE_FILED',
}

export const getProvinciasAction = dispatch => {
  dispatch({
    type: actions.PROVINCIAS_LOAD_REQUESTED,
  })
}

export const updateProvinciaAction = (dispatch, formProvincia) => {
  dispatch({
    type: actions.PROVINCIA_UPDATE_REQUESTED,
    payload: formProvincia,
  })
}
